var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHintInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 18.125a.625.625 0 0 1-.625.625h-6.25a.625.625 0 1 1 0-1.25h6.25a.625.625 0 0 1 .625.625Zm3.125-10a6.85 6.85 0 0 1-2.625 5.406 1.26 1.26 0 0 0-.5 1v.47a1.25 1.25 0 0 1-1.25 1.25h-5A1.25 1.25 0 0 1 6.25 15v-.47a1.265 1.265 0 0 0-.484-.992 6.86 6.86 0 0 1-2.64-5.375c-.024-3.726 2.991-6.828 6.71-6.914a6.868 6.868 0 0 1 7.04 6.875Zm-2.562-.734a4.36 4.36 0 0 0-3.579-3.57.625.625 0 1 0-.203 1.234 3.102 3.102 0 0 1 2.547 2.547.625.625 0 0 0 .617.515h.11a.618.618 0 0 0 .508-.726Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHintInfo);
export default __webpack_public_path__ + "static/media/icon_hint_info.922231f2.svg";
export { ForwardRef as ReactComponent };